import { TRACKED_EVENT_POSITION } from '@/constants/gtag';

// TODO: 10주년 전용 position 확정 시(SOT 미해결 16) 이 한 줄만 교체
export const TEN_YEARS_POSITION = TRACKED_EVENT_POSITION.MAIN_CONTENT;

export const DAY_MS = 24 * 60 * 60 * 1000;

// 포스터 sizes(패널 폭 960, 모바일 전폭) — 임시 모달·모달·미리 받기가 같은 값이어야 캐시가 맞는다
export const POSTER_SIZES = '(min-width: 990px) 960px, 100vw';

// 스토리 제목 id — 모달 dialog 의 aria-labelledby 가 가리킨다(한 화면에 스토리 본문은 하나뿐이다)
export const STORY_TITLE_ID = 'ty-story-title';

// 스토리 패널 모양 — 모달과 단독 페이지가 같이 쓴다. 폭은 POSTER_SIZES, 모서리는 StoryMediaFrame 과 맞물린다
export const PANEL_SHAPE =
  'bg-white lg:mx-auto lg:w-[960px] lg:overflow-hidden lg:rounded-[40px]';

// en.json items 키 — t(`items.${day}.title`) 가 타입 검사를 통과하도록 좁힌다
type StoryItemKey = `${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10}`;
export const storyItemKey = (day: number) => String(day) as StoryItemKey;

// 줄바꿈 태그를 공백으로(한 줄 제목·메타데이터용). 서버 메타데이터가 쓰므로 'use client' 파일에 두면 안 된다
export const INLINE_TAGS = { solidBr: () => ' ' };

export function getNeighborDays(releasedDays: number[], day: number) {
  const index = releasedDays.indexOf(day);
  return {
    prev: index > 0 ? releasedDays[index - 1] : undefined,
    next: index >= 0 ? releasedDays[index + 1] : undefined,
  };
}
